import React from 'react'
import { Label, Table, Button, Icon, Ref } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { sendChart } from '../reducers/chart'
import { hotkeys, hotkey_display } from 'react-keyboard-shortcuts'

const PositionDiff = ({ position, prevPosition }) => {
    if (position === prevPosition)
        return null
    const delta = prevPosition - position
    const triangleDirection = delta > 0 ? 'up' : 'down'
    const triangleColor = delta > 0 ? 'green' : 'red'
    return (<Label>
        <Icon color={triangleColor} name={'triangle ' + triangleDirection} />
        {Math.abs(delta)}
    </Label>)
}

const ChartItem = ({ user, index, isSelf, withAnswers }) => (
    <Table.Row active={isSelf}>
        <Table.Cell singleLine width={1}>{index + 1} <PositionDiff position={user.position} prevPosition={user.prevPosition} /></Table.Cell>
        <Table.Cell width={1}><Label>{user.balance}</Label></Table.Cell>
        <Table.Cell>{user.username}</Table.Cell>
        {withAnswers ? <Table.Cell>{user.lastAnswer}</Table.Cell> : null}
    </Table.Row>
)

class Chart extends React.PureComponent {
    hot_keys = {
        'alt+f': {
            priority: 1,
            handler: (e) => { 
                const { canDownload, socket, onSendClick } = this.props
                if (!canDownload)
                    return
                e.preventDefault()
                onSendClick(socket)
            }
        },

        'alt+h': {
            priority: 1,
            handler: (e) => {
                const { canDownload } = this.props
                if (!canDownload)
                    return
                e.preventDefault()
                this.downloadLink.click()
            }
        }
    }

    handleDownloadRef = downloadLink => this.downloadLink = downloadLink

    render() {
        const { chart, currentUserId, withAnswers, socket, canDownload, onSendClick } = this.props
        return (<Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan={withAnswers ? 4 : 3}>
                        Classifica
                        {canDownload ? 
                            <Button.Group floated='right'>
                                <Ref innerRef={this.handleDownloadRef}>
                                    <Button as='a' href='/api/chart.txt' download='Classifica.txt'>Scarica<br />{hotkey_display('alt+h')}</Button>
                                </Ref>
                                <Button onClick={() => onSendClick(socket)}>Manda<br />{hotkey_display('alt+f')}</Button>
                            </Button.Group> : 
                            null}
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {chart.map((user, i) => <ChartItem key={i} user={user} index={i} isSelf={user.id === currentUserId} withAnswers={withAnswers} />)}
            </Table.Body>
        </Table>)
    }
}


const mapStateToProps = (state, { withAnswers, canDownload }) => ({
    socket: state.socket,
    chart: state.chart,
    currentUserId: state.user.id,
    withAnswers,
    canDownload
})

const mapDispatchToProps = (dispatch) => ({
    onSendClick: (socket) => dispatch(sendChart(socket))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(hotkeys(Chart))


// WEBPACK FOOTER //
// ./src/components/Chart.js